import moment from 'moment'

const objFunc = () => {
  return {
    addresses: [],
    customerId: '',
    customerIds: [],
    mdmId: '',
    customerName: '',
    customerStoreId: null,
    dob: moment(),
    displaySsn: null,
    fullCustomerName: '',
    customerFirstName: '',
    customerLastName: '',
    phoneNumber: '',
    email: '',
    status: 1,
    lastPayDate: {},
    payFrequency: '',
    discretionaryIncome: 0,
    bankAccountId: 0,
    bankName: '',
    bankAccountNumber: '',
    bankRoutingNumber: '',
    hasVerifiedProfileEmail: false,
    hasVerifiedProfilePhone: false,
    /**
     * Stores the Customer ID Reference values to use when updating Cognito attribute.
     */
    lmsReferenceIds: {},

    /**
     * Referral info associated with the customer.
     */
    referralInfo: {},

    /**
     * Customer preferences related to opting in and out of various communication channels.
     */
    communicationSettings: {},

    /**
     * Communication settings that will be applied after the customer goes through the verification process.
     */
    tempCommunicationSettings: {},

    /**
     * If true, allows for changing login credentials when editing contact info, if false editing only saves to the LMS and does not effect Cognito.
     */
    canUpdateUserLogin: false
  }
}

export default objFunc()

export const defaultObj = objFunc()
